import { render, staticRenderFns } from "./Suspended.vue?vue&type=template&id=0ecb57ed&scoped=true&"
import script from "./Suspended.vue?vue&type=script&lang=ts&"
export * from "./Suspended.vue?vue&type=script&lang=ts&"
import style0 from "./Suspended.vue?vue&type=style&index=0&id=0ecb57ed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb57ed",
  null
  
)

export default component.exports